export default {
  path: '/create-student',
  component: resolve => require(['@/components/common/ViewTemplate'], resolve),
  children: [
    {
      path: '',
      redirect: 'index',
    },
    {
      path: 'index',
      component: resolve => require(['@/components/student/create/Index'], resolve),
    },
    {
      path: 'preview',
      component: resolve => require(['@/components/student/create/Preview'], resolve),
    },
    {
      path: 'success',
      component: resolve => require(['@/components/student/create/Success.vue'], resolve),
    },
  ],
};



// WEBPACK FOOTER //
// ./src/router/modules/student/create/index.js